import React, { useMemo } from 'react'
import { Box, Modal } from '@workwhile/ui'
import JsonView from '@uiw/react-json-view'

type PayloadModalProps = {
  payload: string
  onClose: () => void
}

export const PayloadModal = ({ payload, onClose }: PayloadModalProps) => {
  const parsed = useMemo(() => {
    try {
      const value = JSON.parse(payload)
      if (value !== null && typeof value === 'object') {
        return value as object
      }
      return null
    } catch {
      return null
    }
  }, [payload])

  // Modal forwards layout props to its content at runtime; types omit them.
  const modalSizeProps: Record<string, string> = {
    width: '95vw',
    maxWidth: '1200px',
  }

  return (
    <Modal open onClose={onClose} title="Event Payload" {...modalSizeProps}>
      <Box
        style={{
          maxHeight: '75vh',
          overflow: 'auto',
          width: '100%',
        }}
      >
        {parsed !== null ? (
          <JsonView
            value={parsed}
            collapsed={false}
            displayDataTypes={false}
            shortenTextAfterLength={0}
            style={{
              fontSize: 13,
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
            }}
          />
        ) : (
          <pre
            style={{
              margin: 0,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: 13,
            }}
          >
            {payload}
          </pre>
        )}
      </Box>
    </Modal>
  )
}
